import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Box, TextButton, IconChevronDownOutline } from '@zillow/constellation';
import { yieldCallback } from '@zillow/yield-callback';
import React, { useState } from 'react';
import ThemeCmsConstellation from '../../themes/ThemeCmsConstellation.js';
import { getCmsInfoForPage } from '../../utils/clickstream/getCmsInfoForPage.js';
import { usePageProps } from '../PagePropsProvider/PagePropsProvider.js';
import { sendEvent } from './B2BUserNav.utils.js';
import SignOut from './SignOut.js';

var SignIn = function SignIn(_ref) {
  var user = _ref.user,
    signInLink = _ref.signInLink,
    redirectParam = _ref.redirectParam,
    env = _ref.env,
    router = _ref.router,
    inverse = _ref.inverse;
  var pageProps = usePageProps();
  var cmsInfo = getCmsInfoForPage(pageProps);
  var domain = env === 'prod' || env === 'production' ? 'https://www.zillow.com' : 'https://www.qa.zillow.net';
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    dropdown = _useState2[0],
    setDropdown = _useState2[1];
  var signOutURL = domain + '/Logout.htm';
  var redirectUrl = domain + router.asPath;
  var signInURL;
  var isSignInLinkWithDomain = signInLink.startsWith('https');
  if (isSignInLinkWithDomain) {
    signInURL = new URL(signInLink);
  } else {
    signInURL = new URL(domain);
    signInURL.pathname = signInLink;
  }
  signInURL.searchParams.append(redirectParam, redirectUrl);
  var onMouseEnter = function onMouseEnter() {
    setDropdown(true);
  };
  var onMouseLeave = function onMouseLeave() {
    setDropdown(false);
  };
  if (user) {
    return /*#__PURE__*/React.createElement(Box, {
      as: TextButton,
      inverse: inverse,
      fontType: "bodySmall",
      buttonType: "secondary",
      "aria-label": "Account Menu",
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onClick: yieldCallback(function () {
        setDropdown(!dropdown);
      }),
      icon: /*#__PURE__*/React.createElement(IconChevronDownOutline, null),
      iconPosition: "end",
      iconSize: "xs",
      sx: {
        position: 'relative',
        color: inverse ? '$colors.textWhite' : dropdown ? '$colors.blue400' : undefined
      }
    }, dropdown && /*#__PURE__*/React.createElement(Box, {
      sx: {
        top: 0,
        left: "-" + ThemeCmsConstellation.constellation.spacing.md + "px",
        right: "-" + ThemeCmsConstellation.constellation.spacing.sm + "px",
        bottom: "-" + ThemeCmsConstellation.constellation.spacing.xxl * 1.5 + "px",
        position: 'absolute',
        zIndex: "$zIndices.popover"
      }
    }), /*#__PURE__*/React.createElement(Box, {
      as: "span",
      sx: {
        textDecoration: 'none',
        color: 'inherit',
        '@media $sm_lte': {
          display: 'none'
        }
      }
    }, [user.firstName, user.lastName].filter(Boolean).join(' ') || 'My Account'), /*#__PURE__*/React.createElement(Box, {
      as: "span",
      sx: {
        display: 'none',
        textDecoration: 'none',
        color: 'inherit',
        '@media $sm_lte': {
          display: 'block'
        }
      }
    }, "My Account"), /*#__PURE__*/React.createElement(SignOut, {
      url: signOutURL,
      dropdown: dropdown
    }));
  } else if (user === false) {
    return /*#__PURE__*/React.createElement(TextButton, {
      buttonType: "secondary",
      inverse: inverse,
      as: "a",
      href: signInURL.href,
      fontType: "bodySmall",
      onClick: yieldCallback(function () {
        sendEvent('cms_anchor', 'Sign In', signInURL.href, cmsInfo);
      })
    }, "Sign In");
  } else {
    return null;
  }
};
var SignIn$1 = SignIn;

export { SignIn$1 as default };
